<script lang="ts">
    import type { I18NMessage } from "@app/services/i18n.messages";

    import { getMessage } from "@app/services/i18n.service";
    import { slide } from "svelte/transition";

    type MessageType = "info" | "error" | "warn";
    export let messageType: MessageType = "info";
    export let message: I18NMessage = undefined;
    export let messageText: string = undefined;

    let classNames: string = "";
    switch (messageType) {
        case "error": {
            classNames = "bg-red-50 border-red-700 text-red-700";
            break;
        }
        case "warn": {
            classNames = "bg-secondary-50 border-yellow-700 text-gray-900";
            break;
        }
        default:
            classNames = "bg-green-50 border-green-700 text-green-700";
    }
</script>

<p class="p-2 mb-2 rounded border-l-4 text-sm {classNames}" transition:slide>
    {#if message}
        {getMessage(message)}
    {:else if messageText}
        {messageText}
    {:else}
        <slot />
    {/if}
</p>
